module.exports = __webpack_public_path__ + "img/image007.a1deea7f.jpg";